









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '../../store/modules/user';
import { Role } from '../../api/types';

@Component({})
export default class SideBar extends Vue {
  get isSuperadmin() {
    return UserModule.role === Role.SUPERADMIN;
  }

  get isTeacher() {
    return UserModule.jaccountType === 'teacher';
  }

  get isStaff() {
    return UserModule.jaccountType === 'staff';
  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get isCollapse() {
    return !this.sidebar.opened;
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  get menuActive() {
    let menuActive = '/menuEdit';
    ['/menuEdit', '/banner', '/redact', '/account', '/activity', '/profile'].forEach((path) => {
      if (this.$route.path.includes(path)) {
        menuActive = path;
      }
    });
    return menuActive;
  }
}
